<template>
  <div>
    <site-header />
    <main class="cart-page">
      <section class="page-heading">
        <p>Your Bag</p>
        <h1>Shopping Cart</h1>
      </section>

      <section v-if="items.length" class="cart-layout">
        <div class="cart-items">
          <article v-for="item in items" :key="`${item.id}-${item.size}`" class="cart-item">
            <img :src="item.image" :alt="item.name">
            <div>
              <h2>{{ item.name }}</h2>
              <p>{{ item.color }} / {{ item.size }}</p>
              <strong>${{ item.price.toFixed(2) }}</strong>
              <div class="quantity-row">
                <button @click="changeQuantity(item, item.quantity - 1)">-</button>
                <span>{{ item.quantity }}</span>
                <button @click="changeQuantity(item, item.quantity + 1)">+</button>
                <button class="text-button" @click="removeItem(item)">Remove</button>
              </div>
            </div>
          </article>
        </div>
        <aside class="summary-panel">
          <h2>Order Summary</h2>
          <div><span>Subtotal</span><strong>${{ subtotal.toFixed(2) }}</strong></div>
          <div><span>Shipping</span><strong>{{ shippingLabel }}</strong></div>
          <div><span>Estimated Total</span><strong>${{ total.toFixed(2) }}</strong></div>
          <button @click="checkout">Checkout</button>
        </aside>
      </section>

      <section v-else class="empty-state">
        <h1>Your bag is empty</h1>
        <p>Add jackets, denim, hoodies, and everyday essentials to get started.</p>
        <router-link to="/items">Start Shopping</router-link>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { getCart, updateCartItem, removeCartItem } from '@/utils/cart'

export default {
  name: 'Cart',
  components: { SiteHeader, SiteFooter },
  data() {
    return {
      items: getCart()
    }
  },
  computed: {
    subtotal() {
      return this.items.reduce((sum, item) => sum + item.price * item.quantity, 0)
    },
    shipping() {
      return this.subtotal >= 50 || this.subtotal === 0 ? 0 : 6.95
    },
    shippingLabel() {
      return this.shipping === 0 ? 'Free' : `$${this.shipping.toFixed(2)}`
    },
    total() {
      return this.subtotal + this.shipping
    }
  },
  methods: {
    refresh() {
      this.items = getCart()
    },
    changeQuantity(item, quantity) {
      updateCartItem(item.id, item.size, quantity)
      this.refresh()
    },
    removeItem(item) {
      removeCartItem(item.id, item.size)
      this.refresh()
    },
    checkout() {
      this.$router.push({ path: '/login', query: { redirect: '/bag' } })
    }
  }
}
</script>
